import { t } from 'i18n';
import moment from 'moment';
import { notifyError, notifySuccess } from 'utils';

export default (config) => {
  const {
    netlib,
    apiWrap,
    accessToken,
    tenant,
  } = config;

  const createTicket = (body) => apiWrap({
    apiQueryCb: async () => {
      // create unique id with instructions requested by BE
      const M = '4';
      const variants = '89ab';
      const b = crypto.getRandomValues(new Uint8Array(16));
      const x = Array.from(b).map((byte) => byte.toString(16).padStart(2, '0')).join('');
      const idx = Math.abs(crypto.getRandomValues(new Int32Array(1))[0]) % variants.length;
      const N = variants.charAt(idx);
      const TransactionID = `
      ${x.substring(0, 8)}-${x.substring(8, 12)}-${M}${x.substring(13, 16)}-${N}${x.substring(17, 20)}-${x.substring(20)}
      `;

      const { data } = await netlib.CaseApi.createTicket(
        accessToken,
        tenant,
        body,
        {
          ServerSystem: 'XCustomerB2C',
          Operation: 'CreateCaseB2C',
          Functionality: 'CreateCaseB2C',
          ClientSystem: 'EnergyCommunity',
          TransactionID,
          DateTimeMessage: moment().format('YYYYMMDDHHmmssSSS'),
        },
        {
          apiDomain: '/services-fe',
        },
      );
      if (data && data.includes('Operation successfully completed')) {
        notifySuccess(t('ticketSuccess'));
      } else {
        notifyError(t('ticketError'));
      }
      return data;
    },
  });

  return {
    createTicket,
  };
};
